module.exports = __webpack_public_path__ + "static/media/LOGO_HOME_SB_ESP.aa6a78d8.svg";